module.exports = __webpack_public_path__ + "static/media/5.e8ccb3af.jpg";